import { t } from '@lingui/core/macro';
import { NoddiInfoBanner } from 'noddi-ui-web';
import { buildInvoiceText } from '../../../utils/invoiceText';
import { AddOrganizationNumberForm } from './AddOrganizationNumberForm';

type Props = {
  organizationName: string;
  registrationNumber?: string | null;
  /** Distinct invoice recipient. The booking organization stays on the missing-number warning. */
  invoiceToName?: string | null;
  showInvoiceBanner: boolean;
  requiresOrganizationNumber: boolean;
  /** Present when the missing number can be added inline (org id known + source query can be refreshed). */
  organizationId?: number | null;
  onOrganizationNumberSaved?: () => void;
};

/** Invoice-payment info + missing-org-number recovery shared across the stationary summary/proposal screens. */
export const StationaryInvoicePaymentBanners = ({
  organizationName,
  registrationNumber,
  invoiceToName,
  showInvoiceBanner,
  requiresOrganizationNumber,
  organizationId,
  onOrganizationNumberSaved
}: Props) => {
  const orgName = organizationName;
  const invoiceName = invoiceToName ? invoiceToName : organizationName;
  const invoiceText = buildInvoiceText(invoiceName, invoiceToName ? null : registrationNumber);
  const missingOrgText = t`Organization ${orgName} is missing a registration number. Contact support before booking on invoice.`;

  const canAddOrganizationNumber = organizationId != null && !!onOrganizationNumberSaved;

  return (
    <>
      {showInvoiceBanner && (
        <NoddiInfoBanner variant='info' title={t`Invoice payment`} texts={[{ value: invoiceText }]} />
      )}

      {requiresOrganizationNumber &&
        (canAddOrganizationNumber ? (
          <AddOrganizationNumberForm
            organizationId={organizationId}
            organizationName={organizationName}
            onSaved={onOrganizationNumberSaved}
          />
        ) : (
          <NoddiInfoBanner
            variant='warning'
            title={t`Missing organization number`}
            texts={[{ value: missingOrgText }]}
          />
        ))}
    </>
  );
};
